export default __webpack_public_path__ + "static/media/duplicate_all.4c1001d4.svg";